<template>
    <v-sheet color="transparent">
        <template v-if="content">
            <h2 v-if="title && content.title" class="mb-5">{{content.title}}</h2>
            <div v-html="renderedContent"></div>
        </template>
    </v-sheet>
</template>
<script>
    export default {
        name: "RenderContent",
        props: {
            id: {type: String }, 
            title: {type: Boolean, default: true}
        },
        computed: {
            content(){
                return this.$store.state.content.data[this.id]
            },
            renderedContent(){
                if( !this.content ){
                    return "";
                }
                return this.content.html
            }
        },
        watch: {
            id: {
                immediate: true,
                handler() {
                    this.$store.dispatch("content/fetchById", this.id)
                }
            }
        }

    }
</script>